function loader(fn, ...args) {
  return import(/* webpackChunkName: "core_file_async" */ './~file').then(res => {
    return res.default[fn].call(this, ...args);
  });
}

export default {
  /**
   * fileReader第二个参数
   */
  READER_TYPE: {
    // 读取文本文件
    text: 'text',
    // 读取文件并将数据作为base64编码的数据url返回。
    base64: 'base64',
    // 读取文件并将数据作为二进制数据返回。
    binary: 'binary',
    // 读取文件并将数据作为二进制数据缓冲区返回。
    buffer: 'buffer'
  },
  /**
   * 选择文件
   * @param accept    文件类型/文件后缀
   * @param multiple  是否多选
   * @returns {Promise<File | File[] | null>}
   */
  load(accept = "*", multiple = false) {
    return loader('load', accept, multiple);
  },
  /**
   * 读取文件数据，但最后具体内容自行解析
   * @param file 要读取的文件
   * @param type READER_TYPE的值
   * @param encoding 标识type为text时解析文本的编码
   * @returns {Promise<any>}
   */
  fileReader(file, type = "text", encoding = "UTF-8") {
    return loader('fileReader', file, type, encoding);
  },
  /**
   * 解析excel文件类容
   * （常规小文件）
   * @returns {Promise<Object>}
   */
  readXlsx(accept = ".xlsx,.xls,.csv") {
    return loader('readXlsx', accept);
  },
  /**
   * 解析文本文件内容
   * @param accept
   * @returns {Promise<String>}
   */
  readTxt(accept = ".txt") {
    return loader('readTxt', accept);
  },
  /**
   * 解析json文件内容
   * @param accept
   * @returns {Promise<Object>}
   */
  readJSON(accept = ".json") {
    return loader('readJSON', accept);
  },
  /**
   * 懒加载的FileSaver
   * 用法同FileSaver.js
   * @param args
   */
  saveAs(...args) {
    loader('saveAs', ...args);
  },
  /**
   * 非ajax下载文件
   * @param url
   * @param params
   * @param name
   * @param baseUrl
   */
  download (url, params, name, baseUrl) {
    loader.call(this, 'download', url, params, name, baseUrl);
  },
  /**
   * get请求下载文件，参数同 dsf.http.get
   * 需后端返回文件流
   * 文件大小最好不超过500MB，详见https://github.com/eligrey/FileSaver.js
   * 大文件下载请使用 dsf.file.download
   * @param path
   * @param params
   * @param options
   * @param baseUrl
   * @param fileName 文件名（在程序无法获取文件名时请务必提供）
   * @returns {Promise<*>}
   */
  getDownload(path, params, options, baseUrl, fileName) {
    return loader.call(this, 'getDownload', path, params, options, baseUrl, fileName);
  },
  /**
   * post请求下载文件，参数同 dsf.http.post
   * 需后端返回文件流
   * 文件大小最好不超过500MB，详见https://github.com/eligrey/FileSaver.js
   * 大文件下载请使用 dsf.file.download
   * @param path
   * @param params
   * @param options
   * @param baseUrl
   * @returns {Promise<*>}
   */
  postDownload(path, params, options, baseUrl) {
    return loader.call(this, 'postDownload', path, params, options, baseUrl);
  }
};